export default __webpack_public_path__ + "static/media/w3c.b8951f30.svg";